import React, { FunctionComponent } from 'react';
import { ArticlePreview as ArticlePreviewType } from '../../../types/articlePreview';
import { formatDate } from '../../../utils/formatDate';
import { urlFor } from '../../../utils/imageBuilder';
import InternalLink from '../../InternalLink';
import './styles.scss';

type HighlichtCardProps = {
  article: ArticlePreviewType;
  cta?: string | null;
}

const HighlichtCard: FunctionComponent<HighlichtCardProps> = ({ article, cta }) => {
  return (
    <div
      key={article._id}
      className='highlight-card'
    >
      <div>
        <img
          src={urlFor(article.image).width(280).quality(90).url()}
          alt={article.image.alt}
        />
      </div>
      {/* <span>{formatDate(article._createdAt)}</span> */}
      <strong>{article.title}</strong>
      <InternalLink
        reference={article}
        className='primary-button-small'
      >
        {cta ? cta : 'Read more'}
      </InternalLink>
    </div>
  );
}

export default HighlichtCard;
